<template>
  <div>
    <div class="row" style="padding-bottom: 15px">
      <div class="col-md-6">
        <slot name="datepicker"></slot>
      </div>
      <div class="col-md-6 text-right">
        <a href="javascript:void(0);" class="btn btn-outline-primary" @click="$emit('onExport')"
          ><i class="fa fa-print"></i
        ></a>
        <a
          href="javascript:void(0);"
          class="btn btn-outline-primary ml-1"
          @click="$emit('onRefresh')"
          ><i class="fa fa-refresh"></i
        ></a>
      </div>
    </div>

    <div class="row">
      <slot name="filter"></slot>
    </div>

    <div style="padding: 0 5px;">
      <!-- {{orders}} -->
      <order-summary-mobile-item
        v-for="(order, index) in orders"
        :key="'order_' + index"
        v-model="orders[index]"
        @updateOrder="$emit('updateOrder', order.id)"
        @onChangeStatus="$emit('onChangeStatus', order.id)"
      ></order-summary-mobile-item>
    </div>
  </div>
</template>

<script>
import DateRangePicker from '@/components/elements/DateRangePicker'
import OrderSummaryMobileItem from './OrderSummaryMobileItem'

export default {
  props: ['value'],
  data: function() {
    return {
      orders: this.value
      // selectedDate: {
      //     start: ( moment().subtract(1, 'months').toDate()),
      //     end: ( moment().toDate())
      // },
    }
  },
  components: {
    DateRangePicker,
    OrderSummaryMobileItem
  },
  watch: {
    value: function() {
      this.orders = this.value
    }
  },
  methods: {
    updateOrder: function() {
      // console.log(value)
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/OrderSummaryMobile.vue